import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#2A5D7A',
        secondary: '#5E95A0',
        error: '#F02323',
        warning: '#F07A23',
        success: '#6DBF6D'
      }
    }
  }
});
